'use strict';

;jQuery(function () {

    jQuery('#partners .slick').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        arrows: false,
        responsive: [{
            breakpoint: 1199,
            settings: {
                slidesToShow: 5
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }]
    });
});
;jQuery(function ($) {

    var registered = false;
    var initialized = false;

    var queue = [];

    $('.google-maps').each(function (i, el) {

        var $el = $(el);
        var data = $el.data();

        if (!(data.lat && data.lng)) {
            console.error('Missing google map latitude and/or longitude!');
            return;
        }

        if (!initialized) {
            queue.push($el);
            if (!registered) {
                register();
            }
            return;
        }

        resolve($el, data);
    });

    function register() {

        window.__mapCallback = function () {

            this.initialized = true;

            $(queue).each(function (i, $el) {
                resolve($el);
            });
        };

        var key = window.Testlab.config.googleMaps.apiKey;
        var locale = ($('html').attr('lang') || 'en_GB').split('_');

        var src = 'https://maps.googleapis.com/maps/api/js' + '?key=' + key + '&callback=__mapCallback' + '&language=' + locale[0] + '&region=' + locale[1];

        var script = $('<script></script>');
        script.attr('src', src);
        script.attr('async', true);
        script.attr('defer', true);
        $('head').append(script);

        registered = true;
    };

    function resolve($el) {
        var data = $el.data();

        var center = {
            lat: data.lat,
            lng: data.lng
        };

        var map = new google.maps.Map($el.get(0), {
            zoom: data.zoom || 12,
            center: center
        });

        var marker = new google.maps.Marker({
            position: center,
            map: map
        });
    };
});
;jQuery(function ($) {

    var config = (window.Testlab || {}).config;

    if (config && config.cookieBar) {
        $.cookieBar(config.cookieBar);
    }
});